import { AllocationStatus } from "../enums/allocation-status";
import { AllowedActionsMap, StateMachine, TransitionMap } from "./state-machine";

// Domain + UI actions (UI actions don’t affect transitions)
export type AllocationAction =
  | 'Submit' | 'Return' | 'Resubmit' | 'Approve' | 'Reject'  | 'Edit' | 'Delete' | 'CreateProject';

// --- EXACT MIRROR of EnsureValidTransition on server ---
const transitions: TransitionMap<AllocationStatus> = {
  [AllocationStatus.Draft]:        [AllocationStatus.Submitted],
  [AllocationStatus.Submitted]:    [AllocationStatus.Returned, AllocationStatus.Approved, AllocationStatus.Rejected],
  [AllocationStatus.Returned]:     [AllocationStatus.Resubmitted],
  [AllocationStatus.Resubmitted]:  [AllocationStatus.Returned, AllocationStatus.Approved, AllocationStatus.Rejected],
  // Approved/Rejected are terminal -> no entries
};

// --- EXACT MIRROR of EnsureValidAction (+ UI-only Edit/Delete) ---
const allowedActions: AllowedActionsMap<AllocationStatus, AllocationAction> = {
  [AllocationStatus.Draft]:        ['Submit', 'Edit', 'Delete'],
  [AllocationStatus.Submitted]:    ['Return', 'Approve', 'Reject'],
  [AllocationStatus.Returned]:     ['Resubmit', 'Edit'],
  [AllocationStatus.Resubmitted]:  ['Return', 'Approve', 'Reject'],
  [AllocationStatus.Approved]:     ['CreateProject'],
  [AllocationStatus.Rejected]:     [],
};

export const AllocationStateMachine = new StateMachine<AllocationStatus, AllocationAction>({
  transitions,
  allowedActions
});